import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import { BiData } from '@wix/da-bi/pkg/events';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import IconButtonWithContextMenu from '../../../Dropdown/Preset/IconButtonWithContextMenuV2';
var MoreMenu = function (_a) {
    var className = _a.className, menuClassName = _a.menuClassName;
    var t = useTranslation().t;
    var kill_prints_act_one = useFlag('kill_prints_act_one');
    var items = useMemo(function () { return [
        {
            key: 'groups',
            label: t('siteHeader.groups'),
            link: Url.buildFromPath(URLS.GROUPS),
            biData: BiData({
                evid: 700,
                link_name: 'groups',
                link_url: Url.buildFromPath(URLS.GROUPS),
            }),
        },
        !kill_prints_act_one && {
            key: 'prints',
            label: t('siteHeader.prints'),
            link: Url.buildFromPath(URLS.PRINTS),
            biData: BiData({
                evid: 700,
                link_name: 'shop',
                link_url: Url.buildFromPath(URLS.PRINTS),
            }),
        },
        {
            key: 'forum',
            label: t('siteHeader.forum'),
            link: Url.buildFromPath(URLS.FORUM),
            biData: BiData({
                evid: 700,
                link_name: 'forum',
                link_url: Url.buildFromPath(URLS.FORUM),
            }),
        },
        {
            key: 'whatsNew',
            label: t('siteHeader.whatsNew'),
            link: URLS.TEAM,
            target: '_blank',
            biData: BiData({
                evid: 700,
                link_name: 'whatsNew',
                link_url: URLS.TEAM,
            }),
        },
        {
            key: 'daProtect',
            label: t('siteHeader.daProtect'),
            newTag: false,
            link: "".concat(URLS.PROTECT, "?utm_source=DA&utm_medium=banner&utm_campaign=DA_top_nav&utm_id=DA_top_nav"),
            target: '_blank',
            biData: BiData({
                evid: 700,
                link_name: 'protect',
                link_url: URLS.PROTECT,
            }),
        },
        {
            key: 'monetize',
            label: t('siteHeader.monetize'),
            newTag: true,
            link: URLS.DEVIANTART_SELL,
            target: '_blank',
            biData: BiData({
                evid: 700,
                link_name: 'deviantartsell',
                link_url: URLS.DEVIANTART_SELL,
            }),
        },
    ]; }, [t]);
    return (React.createElement(IconButtonWithContextMenu, { className: className, standardMenuProps: { className: menuClassName }, popperManagerProps: { isInPopup: true }, placement: "bottom-end", openOnHover: true, items: items, size: "large", variant: "main", icon: EllipsisIcon, "aria-label": t('siteHeader.more') }));
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;
//# sourceMappingURL=MoreMenu.js.map